
(function () {
  if (window.customerDetailsInitialized) return;
  window.customerDetailsInitialized = true;

  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzHf2V0HBlo0T-sW8p0YfzBYf4_n5S1NjRJ7lg9duRX5DyBkpy_Re3R6oLmb6vEDZal0A/exec';

  const modal = document.getElementById('CustomerDetailsModal');
  if (!modal) return;

  const nameInput = modal.querySelector('[data-customer-name]');
  const phoneInput = modal.querySelector('[data-customer-phone]');
  const stateInput = modal.querySelector('[data-customer-state]');
  const error = modal.querySelector('[data-customer-error]');
  const continueButton = modal.querySelector('[data-customer-continue]');

  let activeForm = null;
  let activeButton = null;
  let submitting = false;

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  function openModal(button, form) {
    activeButton = button;
    activeForm = form;

    error.hidden = true;
    modal.hidden = false;
    document.body.classList.add('sheet-customer-open');

    nameInput.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('sheet-customer-open');
    activeForm = null;
    activeButton = null;
  }

  // Capture standard Add to Cart buttons before theme handlers run.
  
document.addEventListener('click', function (event) {
  const quickViewButton = event.target.closest(
    '.js-product-card-quick-view-button'
  );

  const button = event.target.closest(
    'button[name="add"], button.add-to-cart, ' +
    '.product-sticky-add-to-cart__button, ' +
    '.product-card button[type="submit"][name="add"]'
  );

  // Handle product-card quick-view / Add to Cart buttons.
  if (quickViewButton) {
    if (quickViewButton.disabled || submitting) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const productCard = quickViewButton.closest('.js-product-card');
    const productHandle =
      quickViewButton.dataset.productCardHandle;
    const variantId = quickViewButton.dataset.variant || '';

    if (!productCard || !productHandle) {
      console.error('Product card or product handle not found.');
      return;
    }

    // Store the product information for the shared modal.
    activeButton = quickViewButton;
    activeForm = null;

    modal.dataset.productHandle = productHandle;
    modal.dataset.variantId = variantId;

    error.hidden = true;
    modal.hidden = false;
    document.body.classList.add('sheet-customer-open');
    nameInput.focus();

    return;
  }

  // Handle standard product-page and sticky Add to Cart buttons.
  if (!button || button.disabled || submitting) return;

  const form = button.form ||
    button.closest('form[action*="/cart/add"]');

  if (!form) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  activeButton = button;
  activeForm = form;

  modal.dataset.productHandle = '';
  modal.dataset.variantId =
    form.querySelector('[name="id"]')?.value || '';

  error.hidden = true;
  modal.hidden = false;
  document.body.classList.add('sheet-customer-open');
  nameInput.focus();
}, true);


  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-customer-close]') && !submitting) {
      closeModal();
    }
  });

 
    continueButton.addEventListener('click', async function () {
    if (submitting || !activeButton) return;

    const name = nameInput.value.trim();
    const phone = phoneInput.value.trim();
    const state = stateInput.value.trim();

    error.hidden = true;

    if (!name || !phone || !state) {
        showError('Please fill in Name, Phone Number, and State.');
        return;
    }

    const formToSubmit = activeForm;
    const productHandle = modal.dataset.productHandle || '';
    const variantId =
        modal.dataset.variantId ||
        formToSubmit?.querySelector('[name="id"]')?.value ||
        '';

    if (!variantId) {
        showError('Could not identify the selected product variant. Please refresh and try again.');
        return;
    }

    if (
        !SCRIPT_URL.startsWith('https://script.google.com/macros/s/') ||
        !SCRIPT_URL.endsWith('/exec')
    ) {
        showError('The Google Sheets endpoint URL is not configured.');
        return;
    }

    submitting = true;
    continueButton.disabled = true;
    continueButton.textContent = 'Submitting...';

    try {
        let productName = document.querySelector('h1')?.textContent.trim()
        || document.title;
        let productId = '';

        // Product-card buttons have no form, so look up the product by handle.
        if (productHandle) {
        const productResponse = await fetch(
            `/products/${encodeURIComponent(productHandle)}.js`
        );

        if (!productResponse.ok) {
            throw new Error('Could not load product details.');
        }

        const product = await productResponse.json();
        productName = product.title;
        productId = String(product.id);
        } else {
        // For a product-page form, derive the handle from its product URL.
        const pathMatch = window.location.pathname.match(/^\/products\/([^/]+)/);

        if (pathMatch) {
            const productResponse = await fetch(
            `/products/${pathMatch[1]}.js`
            );

            if (productResponse.ok) {
            const product = await productResponse.json();
            productName = product.title;
            productId = String(product.id);
            }
        }

        // Fallback if the product page lookup did not provide an ID.
        if (!productId) productId = variantId;
        }

        const data = new URLSearchParams({
        name,
        phone,
        state,
        product_name: productName,
        product_id: productId
        });

        // no-cors does not let the browser verify that Google Sheets saved the row.
        await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: data
        });

        if (formToSubmit) {
        // Existing product-page or sticky Add to Cart form.
        closeModal();

        if (formToSubmit.requestSubmit) {
            formToSubmit.requestSubmit();
        } else {
            HTMLFormElement.prototype.submit.call(formToSubmit);
        }
        } else {
        // Product-card button: add its selected variant to Shopify's cart.
        const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
            body: JSON.stringify({
            items: [{
                id: Number(variantId),
                quantity: 1
            }]
            })
        });

        if (!cartResponse.ok) {
            let message = 'Could not add this product to your cart.';
            try {
            const cartError = await cartResponse.json();
            if (cartError.description) message = cartError.description;
            } catch (_) {}
            throw new Error(message);
        }

        closeModal();

        // Refresh the cart drawer HTML from Shopify.
        try {
        const sectionResponse = await fetch(
            `${window.location.pathname}?sections=cart-drawer`
        );

        // The exact section key depends on the theme's section ID.
        // First try to refresh the existing drawer through Shopify's cart API.
        const cartResponse = await fetch('/cart.js', {
            headers: { Accept: 'application/json' }
        });

        if (!cartResponse.ok) {
            throw new Error('Could not refresh cart.');
        }

        // Notify Bijou's cart scripts that the cart has changed.
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        const drawer = document.querySelector('#CartDrawer');

        if (!drawer) {
            throw new Error('Bijou cart drawer element was not found.');
        }

        // Use the theme's own toggle control if available.
        const toggle = document.querySelector(
            '[data-js-toggle="CartDrawer"]'
        );

        if (toggle) {
            toggle.click();
        } else {
            throw new Error(
            'Could not find Bijou’s cart drawer toggle. Check cart-drawer.js.'
            );
        }
        } catch (err) {
        console.error('Bijou cart drawer error:', err);
        showError(
            'The product was added, but the cart drawer could not be opened. Please open the cart manually.'
        );
        }

        }
    } catch (e) {
        console.error('Customer details / cart error:', e);
        showError(e.message || 'Something went wrong. Please try again.');
    } finally {
        submitting = false;
        continueButton.disabled = false;
        continueButton.textContent = 'Continue to Cart';
    }
    });

})();
